<template>
   <div class="row">
      <div class="col">{{label}}:
         <div v-if="hierarchies!=undefined && hierarchies.length>0" id="ddlDiv">
            <div class="dropdown">
               <button type="button" class="btn dropdown-toggle hier-btn" data-toggle="dropdown" v-if="selectedHierarchy != null && showBlocks">
                  {{selectedHierarchy.carrier}} - {{selectedHierarchy.blockNo}} -    {{selectedHierarchy.agentNo}}
               </button>
               <button type="button" class="btn dropdown-toggle hier-btn" data-toggle="dropdown" v-if="selectedHierarchy != null && !showBlocks">
                   {{(isHealthBlock(selectedHierarchy.blockNo) ? selectedHierarchy.agentNo + " - HEALTH" : selectedHierarchy.agentNo + " - LIFE \u00a0\u00a0\u00a0\u00a0")}}
               </button>
               <button type="button" class="btn dropdown-toggle hier-btn" data-toggle="dropdown" v-if="selectedHierarchy==null">
                  (Select a Hierarchy)
               </button>
               <div class="dropdown-menu hier-ctn" v-if="showBlocks">
                  <a  v-for="(h, indx) in hierarchies" :key="indx" :value="h" class="dropdown-item hiera" href="#" 
                     v-tooltip:left="'Carrier: '+h.carrier+', MGACode: '+h.mgaCode+', Agent#: '+h.agentNo"
                     @click.prevent="hierarchyChanged(h)"
                  >
                   {{h.carrier}} - {{h.blockNo}} -      {{h.agentNo}}
                  </a>
               </div>
               <div v-else class="dropdown-menu hier-ctn">
                  <a  v-for="(h, indx) in hierarchies" :key="indx" :value="h" class="dropdown-item hiera" href="#" 
                     v-tooltip:left="'Carrier: '+h.carrier+', MGACode: '+h.mgaCode+', Agent#: '+h.agentNo"
                     @click.prevent="hierarchyChanged(h)"
                  >
                   {{h.agentNo}} - {{(isHealthBlock(h.blockNo) ? "HEALTH" : "LIFE" )}}
                  </a> 
               </div>
            </div>
         </div>
         <div v-else class="text-danger">(none)</div>
      </div>
   </div>
</template>


<script>
           

export default {
   name: "ddl",
   props: ['hierarchies', 'selectedHierarchy','caption', 'showBlocks', 'healthBlockNumbers'],
   data() {
      return {
         label: '',
         hasCaption: false
      };
   },
   mounted() {
      if (this.caption && this.caption != '') {
         this.hasCaption = true
         this.label = this.caption
      } else {
         this.label = 'Hierarchies'
      }
   },
   methods: {
      hierarchyChanged(itm) {
         this.$emit("hier-changed", itm);
      },
      isHealthBlock(block)
      {
         var blockNumbers = [72, 87, 215, 216, 140, 213]
         return blockNumbers.some((b) => b === block)
      },
   },
};
</script>

<style scoped lang="scss">
.hier-btn {
   background-color: transparent;
   outline: none;
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
}
.hier-ctn {
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
   padding: 0;
}
.hiera {
   line-height:24px;
   border-width: 0 1px 1px 1px;
   border-style: solid;
   border-color: #ccc;
   width: 100%;
}
#ddlDiv {
   display: inline-block;
}
</style>